import { OpeningTimes } from './OpeningTimes';
import React from 'react';

export interface OpeningTimesContainerProps {
  testId?: string;
  show: boolean;
}

export const OpeningTimesContainer = (props: OpeningTimesContainerProps) => {
  return <OpeningTimes {...props} />;
};
